var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetworth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 29,
    viewBox: "0 0 23 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.41515 26.5373H4.25186V17.3538H2.41515V26.5373ZM5.17021 28.374H1.49681C0.988963 28.374 0.578461 27.9635 0.578461 27.4556V16.4354C0.578461 15.9276 0.988963 15.5171 1.49681 15.5171H5.17021C5.67806 15.5171 6.08856 15.9276 6.08856 16.4354V27.4556C6.08856 27.9635 5.67806 28.374 5.17021 28.374Z",
    fill: "#427A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6803 26.5369H12.517V10.0066H10.6803V26.5369ZM13.4353 28.3736H9.76192C9.25407 28.3736 8.84357 27.9631 8.84357 27.4553V9.08827C8.84357 8.58042 9.25407 8.16992 9.76192 8.16992H13.4353C13.9432 8.16992 14.3537 8.58042 14.3537 9.08827V27.4553C14.3537 27.9631 13.9432 28.3736 13.4353 28.3736Z",
    fill: "#427A0A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9454 26.5371H20.7821V2.65994H18.9454V26.5371ZM21.7005 28.3738H18.0271C17.5192 28.3738 17.1087 27.9632 17.1087 27.4554V1.74159C17.1087 1.23374 17.5192 0.823242 18.0271 0.823242H21.7005C22.2083 0.823242 22.6188 1.23374 22.6188 1.74159V27.4554C22.6188 27.9632 22.2083 28.3738 21.7005 28.3738Z",
    fill: "#427A0A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworth);
export default __webpack_public_path__ + "static/media/networth.4116545fb6f164fc07334f05f55b30fa.svg";
export { ForwardRef as ReactComponent };